import React from 'react';
import { Phone, MapPin } from 'lucide-react';
export function ThankYouDetails() {
  return <div className="bg-paper p-8 rounded-2xl shadow-soft border border-subtle-gray flex flex-col sm:flex-row justify-center gap-8 mb-12" data-id="element-3481">
      <div className="flex flex-col items-center gap-2" data-id="element-3482">
        <Phone className="w-6 h-6 text-storm-red" data-id="element-3483" />
        <span className="font-bold text-ink" data-id="element-3484">Questions? Call Us</span>
        <a href="tel:517-220-0621" className="text-gray-warm hover:text-storm-red transition-colors" data-id="element-3485">
          517-220-0621
        </a>
      </div>
      <div className="hidden sm:block w-px bg-subtle-gray" data-id="element-3486"></div>
      <div className="flex flex-col items-center gap-2" data-id="element-3487">
        <MapPin className="w-6 h-6 text-storm-red" data-id="element-3488" />
        <span className="font-bold text-ink" data-id="element-3489">Location</span>
        <span className="text-gray-warm text-center" data-id="element-3490">
          24786 Crestview
          <br data-id="element-3491" />
          Farmington Hills, MI
        </span>
      </div>
    </div>;
}